import React from 'react';
import axios from 'helpers/axios';
import config from 'helpers/config';
import RepairOrder from 'models/RepairOrderModel';
import { FaCheckCircle, FaEdit, FaRegTrashAlt, FaSort, FaTimesCircle } from 'react-icons/fa';
import history from 'helpers/history';
import TableColumn from 'models/TableColumnModel';
import ColumnsPicker from 'components/common/ColumnsPicker';
import RelativeTime from 'components/common/RelativeTime';
import Avatar from 'react-avatar';
import moment from 'moment';
import NewDropdown from 'components/common/NewDropdown';
import Toggle from 'components/common/Toggle';
import SearchQueryParamsModel from 'models/common/SearchQueryParamsModel';
import OrderByQueryModel from 'models/common/OrderByQueryModel';
import DateRangeQueryModel from 'models/common/DateRangeQueryModel';
import DateRangeType from 'models/types/DateRangeTypes';
import placeholders from 'helpers/placeholders';
import Pagination from 'components/common/Pagination';
import dateFormats from 'helpers/dateFormats';
import Price from 'components/common/Price';

interface Props {}

interface State {
    repairOrders: RepairOrder[];
    tableColumns: TableColumn[];
    orderBy: string;
    searchPhrase: string;
    resultsCount: number;

    dateRange: DateRangeType;
    dateFrom: string;
    dateTo: string;
    page: number;
    itemsPerPage: number;
}

class ArchivePage extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {
            repairOrders: [],
            tableColumns: repairOrderListColumns,
            orderBy: 'createdAt.DESC',
            dateRange: DateRangeType.AllTime,
            searchPhrase: '',
            resultsCount: 0,

            dateFrom: new Date(new Date().setMonth(new Date().getMonth() - 1)).toISOString().slice(0, 10),
            dateTo: new Date().toISOString().slice(0, 10),
            page: 1,
            itemsPerPage: 10,
        };

        this.handleSearch = this.handleSearch.bind(this);
        this.pageChanged = this.pageChanged.bind(this);
    }

    componentDidMount() {
        const queryParams: SearchQueryParamsModel & OrderByQueryModel & DateRangeQueryModel = {
            orderBy: this.state.orderBy,
            dateRange: this.state.dateRange,

            searchPhrase: this.state.searchPhrase,
            page: this.state.page,
            itemsPerPage: this.state.itemsPerPage,
            archivedOnly: true,
            dateFrom: new Date(this.state.dateFrom),
            dateTo: new Date(this.state.dateTo),
        };

        this.getRepairOrders(queryParams);
    }

    getRepairOrders(queryParams: SearchQueryParamsModel & OrderByQueryModel) {
        axios
            .get(`${config.apiUrl}/repairOrder`, { params: queryParams })
            .then((res) => {
                this.setState({ repairOrders: res.data.rows, resultsCount: res.data.count });
            })
            .catch((_) => {
                console.log(_);
            });
    }

    isColumnActive(columnName: string) {
        return this.state.tableColumns.find((column) => column.name === columnName)?.active;
    }

    handleSearch(event: React.FormEvent<HTMLInputElement>) {
        const { value } = event.currentTarget;
        this.setState(
            {
                searchPhrase: value,
                page: 1,
            },
            this.componentDidMount,
        );
    }

    pageChanged(page?: number) {
        if (page) {
            this.setState({ page }, () => this.componentDidMount());
        }
    }

    render() {
        const { repairOrders, tableColumns, resultsCount, page, itemsPerPage } = this.state;
        return (
            <div className="list-page">
                <div className="flex">
                    <div className="font-bold text-xl">Repair Orders Archive</div>
                    {/* <div className="ml-auto">
                        <ColumnsPicker
                            columns={tableColumns}
                            onChange={(updatedColumns) => this.setState({ tableColumns: updatedColumns })}
                        />
                    </div> */}
                </div>
                <div className="search-add-row items-center mt-3">
                    <input
                        onChange={this.handleSearch}
                        name="searchPhrase"
                        placeholder={placeholders.RO_ARCHIVE_SEARCH}
                        className="bg-white placeholder  placeholder-gray-400 placeholder-font-bold rounded-xl border border-green-500 px-2 py-1 font-medium w-1/3 focus:ring-1 focus:outline-none focus:border-blue-500"
                    ></input>
                    <div className="ml-auto">
                        <ColumnsPicker
                            columns={tableColumns}
                            onChange={(updatedColumns) => this.setState({ tableColumns: updatedColumns })}
                        />
                    </div>
                </div>

                {/* Filters section */}
                <div className="my-4 p-3 border border-gray-600 rounded-lg bg-white">
                    <div className="flex">
                        {/* <div className="flex mr-6">
                            <span className="text-gray-500 font-semibold mr-4">Include Sales tax: </span>
                            <div>
                                <Toggle
                                    value={false}
                                    name="collectPayments"
                                    onChange={function (newValue: boolean): void {
                                        console.log(newValue);
                                    }}
                                />
                            </div>
                        </div> */}
                        <div className="flex mr-6">
                            <span className="text-gray-500 font-semibold mr-4">Order by: </span>
                            <div className="">
                                <NewDropdown
                                    items={orderByOptions}
                                    bindName={'name'}
                                    onSelect={(orderBy) => {
                                        this.setState(
                                            {
                                                orderBy: orderBy.value,
                                            },
                                            this.componentDidMount,
                                        );
                                    }}
                                    isServiceCard={true}
                                    selected={orderByOptions.find((option) => option.value === this.state.orderBy)}
                                    verticalPadding="py-0"
                                />
                            </div>
                        </div>
                        <div className="flex mr-1.5">
                            <span className="text-gray-500 font-semibold mr-4">From: </span>
                            <NewDropdown
                                items={dateRangeOptions}
                                isServiceCard={true}
                                bindName={'name'}
                                onSelect={(dateRange) => {
                                    this.setState(
                                        {
                                            dateRange: dateRange.value,
                                        },
                                        this.componentDidMount,
                                    );
                                }}
                                selected={dateRangeOptions.find((option) => option.value === this.state.dateRange)}
                                verticalPadding="py-0"
                            />
                        </div>

                        {this.state.dateRange === DateRangeType.Custom && (
                            <div className="flex">
                                <div className="mr-2">
                                    <input
                                        type="date"
                                        value={this.state.dateFrom}
                                        onChange={(e) =>
                                            this.setState(
                                                {
                                                    dateFrom: new Date(e.target.value).toISOString().slice(0, 10),
                                                },
                                                this.componentDidMount,
                                            )
                                        }
                                        className={`bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full pl-10 p-2.5 py-1 mr-1`}
                                        placeholder="Select date"
                                    />
                                </div>
                                <span className="mr-2">To:</span>
                                <div className="mr-2">
                                    <input
                                        type="date"
                                        value={this.state.dateTo}
                                        onChange={(e) =>
                                            this.setState(
                                                {
                                                    dateTo: new Date(e.target.value).toISOString().slice(0, 10),
                                                },
                                                this.componentDidMount,
                                            )
                                        }
                                        className={`bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full pl-10 p-2.5 py-1 mr-1`}
                                        placeholder="Select date"
                                    />
                                </div>
                            </div>
                        )}
                    </div>
                </div>
                {/* Filters section */}
                <div>
                    <div className="text-gray-500 font-semibold mb-2">
                        Showing {repairOrders.length} of {resultsCount} results
                    </div>
                </div>
                <div className="overflow-x-auto">
                    <table className="items-center w-full ">
                        <thead>
                            <tr className=" text-white bg-gray-200 font-extrabold  text-left text-xs uppercase align-middle">
                                {tableColumns.map(
                                    (column, index) =>
                                        column.active && (
                                            <th key={index} className={`pl-6 py-3 ${index === 0 && 'rounded-tl-md'}`}>
                                                <span className="clickable text-blue-500 font-bold ">
                                                    <span>{column.text}</span>
                                                    {!!column.sortable && <FaSort className="inline ml-1" />}
                                                </span>
                                            </th>
                                        ),
                                )}
                                <th className="px-6 py-3 rounded-tr-md"></th>
                            </tr>
                        </thead>

                        <tbody>
                            {!!repairOrders &&
                                repairOrders.map((RO) => (
                                    <tr
                                        className={`border-b font-semibold hover:bg-blue-200 clickable bg-white border-r-2 border-l-2`}
                                        key={RO.id}
                                        onClick={() => {
                                            history.push(`/repairOrder/${RO.id}`);
                                        }}
                                    >
                                        {this.isColumnActive('repairOrderNumber') && (
                                            <td className="px-6 align-middle whitespace-nowrap p-3 text-blue-400 ">
                                                <span className="align-baseline">
                                                    <span>#{RO.repairOrderNumber}</span>
                                                </span>
                                            </td>
                                        )}
                                        {this.isColumnActive('orderName') && (
                                            <td className="px-6 align-middle whitespace-nowrap p-3 text-blue-400">
                                                <span>
                                                    <span>{RO.title}</span>
                                                </span>
                                            </td>
                                        )}
                                        {this.isColumnActive('customer') && (
                                            <td className="px-6 align-middle whitespace-nowrap p-3">
                                                <div>
                                                    <div>
                                                        {!!RO.vehicle ? (
                                                            <div>
                                                                <div>
                                                                    <span>
                                                                        {RO.vehicle?.year} {RO.vehicle?.make}{' '}
                                                                        {RO.vehicle?.model}
                                                                    </span>
                                                                </div>
                                                                <div>
                                                                    <small>{RO.vehicle.VIN}</small>
                                                                </div>
                                                            </div>
                                                        ) : (
                                                            <span className="text-gray-400 font-medium">
                                                                No vehicle
                                                            </span>
                                                        )}
                                                    </div>
                                                    <div>
                                                        {!!RO.customer ? (
                                                            <span className="font-medium">
                                                                {RO.customer?.firstName} {RO.customer?.lastName}
                                                            </span>
                                                        ) : (
                                                            <span className="text-gray-400 font-medium">
                                                                No customer
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>
                                            </td>
                                        )}
                                        {this.isColumnActive('total') && (
                                            <td className="px-6 align-middle whitespace-nowrap p-3">
                                                <Price
                                                    price={
                                                        RO.services.reduce(
                                                            (acc, service) => acc + service.grandTotalCents,
                                                            0,
                                                        ) / 100
                                                    }
                                                />
                                            </td>
                                        )}
                                        {this.isColumnActive('due') && (
                                            <td className="px-6 align-middle whitespace-nowrap p-3 text-blue-400">
                                                {!!RO?.dueDate && (
                                                    <span>
                                                        <span>
                                                            {moment(RO?.dueDate).format(dateFormats.USA_DATETIME)}
                                                        </span>
                                                    </span>
                                                )}
                                            </td>
                                        )}

                                        {this.isColumnActive('paidStatus') && (
                                            <td className="px-6 align-middle whitespace-nowrap p-3 text-blue-400">
                                                {Math.random() < 0.5 ? (
                                                    <span className="bg-green-500 rounded-lg text-white px-2">
                                                        Paid
                                                    </span>
                                                ) : (
                                                    <span className="bg-yellow-500 rounded-lg text-white px-2">
                                                        Unpaid
                                                    </span>
                                                )}
                                            </td>
                                        )}
                                        {this.isColumnActive('workflow') && (
                                            <td className="px-6 align-middle whitespace-nowrap p-3 text-blue-400">
                                                <span>
                                                    <span>{RO.workflowStatus?.name}</span>
                                                </span>
                                            </td>
                                        )}
                                        {this.isColumnActive('inspectionStatus') && (
                                            <td className="px-6 align-middle whitespace-nowrap p-3 text-blue-400">
                                                <span>
                                                    <span>{RO.workflowStatus?.name}</span>
                                                </span>
                                            </td>
                                        )}
                                        {this.isColumnActive('orderStatus') && (
                                            <td className="px-6 align-middle whitespace-nowrap p-3 text-blue-400">
                                                <span>
                                                    <span>{RO?.status === 1 ? 'Invoice' : 'Estimate'}</span>
                                                </span>
                                            </td>
                                        )}
                                        {this.isColumnActive('authorizationStatus') && (
                                            <td className="px-6 align-middle whitespace-nowrap p-3 text-blue-400">
                                                <span>
                                                    <FaCheckCircle className="text-green-500" />
                                                </span>
                                            </td>
                                        )}
                                        {this.isColumnActive('technicians') && (
                                            <td className="px-6 align-middle whitespace-nowrap p-3 text-blue-400">
                                                <span>
                                                    {!!(RO?.asignees?.length > 0) &&
                                                        RO.asignees.map((asignee, index) => (
                                                            <Avatar
                                                                name={`${asignee.firstName} ${asignee.lastName}`}
                                                                round
                                                                size={'22'}
                                                                className="clickable"
                                                                key={index}
                                                            />
                                                        ))}
                                                </span>
                                            </td>
                                        )}
                                        {this.isColumnActive('dateCreated') && (
                                            <td className="px-6 align-middle whitespace-nowrap p-3 text-blue-400">
                                                <span className="float-left">
                                                    <RelativeTime dateTime={RO.createdAt} />
                                                </span>
                                                <br />
                                                <span>
                                                    <span className="text-sm">
                                                        {moment(RO.createdAt).format(dateFormats.USA_DATETIME)}
                                                    </span>
                                                </span>
                                            </td>
                                        )}
                                        {this.isColumnActive('labels') && (
                                            <td className="px-6 align-middle whitespace-nowrap p-3 text-blue-400">
                                                {RO.labels?.map((label, indx) => (
                                                    <span
                                                        key={indx}
                                                        style={{ backgroundColor: label.color }}
                                                        className="mr-2 px-1 py-1 rounded-lg hover:opacity-80 text-xs"
                                                    >
                                                        <span className="font-semibold text-white inline-flex whitespace-nowrap">
                                                            <FaTimesCircle
                                                                // onClick={() => this.removeLabel(indx)}
                                                                className="inline mr-1 clickable align-baseline text-xs"
                                                            />
                                                            {label.title}
                                                        </span>
                                                    </span>
                                                ))}
                                            </td>
                                        )}

                                        <td className="px-6 align-middle whitespace-nowrap p-3 non-clickable">
                                            <FaRegTrashAlt
                                                size={15}
                                                className="inline clickable mr-1"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    // this.handleDelete(RO);
                                                }}
                                            />
                                            <FaEdit
                                                size={15}
                                                className="inline clickable"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    // onEdit(RO.id!);
                                                }}
                                            />
                                        </td>
                                    </tr>
                                ))}
                        </tbody>
                    </table>
                </div>
                <Pagination
                    currentPage={page}
                    pageSize={itemsPerPage}
                    totalItems={resultsCount}
                    pageChanged={this.pageChanged}
                ></Pagination>
            </div>
        );
    }
}

export default ArchivePage;

const repairOrderListColumns: TableColumn[] = [
    {
        name: 'repairOrderNumber',
        active: true,
        text: 'RO #',
        sortable: true,
    },
    {
        name: 'orderName',
        active: true,
        text: 'Order Name',
        sortable: true,
    },
    {
        name: 'customer',
        active: true,
        text: 'Vehicle, Customer',
        sortable: false,
    },
    {
        name: 'total',
        active: true,
        text: 'Total',
        sortable: true,
    },
    {
        name: 'due',
        active: true,
        text: 'Due',
        sortable: true,
    },
    {
        name: 'paidStatus',
        active: true,
        text: 'Paid Status',
        sortable: true,
    },
    {
        name: 'workflow',
        active: true,
        text: 'Workflow',
        sortable: true,
    },
    {
        name: 'inspectionStatus',
        active: true,
        text: 'Inspection Status',
        sortable: true,
    },
    {
        name: 'orderStatus',
        active: true,
        text: 'Order Status',
        sortable: true,
    },

    {
        name: 'authorizationStatus',
        active: true,
        text: 'Authorization Status',
        sortable: true,
    },
    {
        name: 'technicians',
        active: true,
        text: 'Technicians',
        sortable: true,
    },
    {
        name: 'dateCreated',
        active: true,
        text: 'Date Created',
        sortable: true,
    },
    {
        name: 'labels',
        active: true,
        text: 'Labels',
        sortable: true,
    },
];

const orderByOptions = [
    {
        id: 777,
        name: 'Newest',
        value: 'createdAt.DESC',
    },
    {
        id: 0,
        name: 'Oldest',
        value: 'createdAt.ASC',
    },
    {
        id: 2,
        name: 'Amount paid: highest first',
        value: 'amount.DESC',
    },
    {
        id: 3,
        name: 'Amount paid: lowest first',
        value: 'amount.ASC',
    },
];

const dateRangeOptions = [
    {
        id: 777,
        name: 'All Time',
        value: DateRangeType.AllTime,
    },
    {
        id: 0,
        name: 'Last 24h',
        value: DateRangeType.Last24Hours,
    },
    {
        id: 2,
        name: 'Past Week',
        value: DateRangeType.PastWeek,
    },
    {
        id: 3,
        name: 'Past Month',
        value: DateRangeType.PastMonth,
    },
    {
        id: 4,
        name: 'Past Year',
        value: DateRangeType.PastYear,
    },
    {
        id: 5,
        name: 'Custom',
        value: DateRangeType.Custom,
    },
];
